import type { RouteObject } from 'react-router-dom';

import { AppLayout } from '@/components/layout/AppLayout';

import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Feature routes (glob registry — `src/features/registry.ts`):
 * - `/login` is public (design §5.1); it self-redirects to `/` when a session
 *   already exists.
 * - `/` mounts the protected app shell; its index is the dashboard landing
 *   view. Unauthenticated visits hit `ProtectedRoute` → `/login`.
 *   Sidebar entries this feature contributes live in `features/auth/nav.ts`.
 *   Other features claim their own paths (e.g. `/organizations`) with the same
 *   `<ProtectedRoute><AppLayout /></ProtectedRoute>` layout element.
 */
export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <DashboardPage /> }],
  },
];
